import { NavLink, Outlet } from "react-router-dom";
import Button from "../../components/ui/Button";
import StrokeTitle from "../../components/ui/StrokeTitle";
import ReactPlayer from "react-player";
import { useState } from "react";
import Modal from "../../components/ui/Modal";
import AltTitle from "../../components/ui/AltTitle";

const CombatSystem = () => {
  return (
    <>
      <div className="text-wrapper">
        <div className="page-nav">
          <NavLink to="jumbification">
            <Button text="Jumbification" color="red"/>
          </NavLink>
          <NavLink to="kill-tech">
            <Button text="Certain-Kill Techniques" color="red"/>
          </NavLink>
          <NavLink to="ai-battle">
            <Button text="AI Battles" color="red"/>
          </NavLink>
          <NavLink to="basic">
            <Button text="Basic Systems" color="red"/>
          </NavLink>
          <NavLink to="ranked-battle">
            <Button text="Ranked Battles" color="red"/>
          </NavLink>
          <NavLink to="hell-mode">
            <Button text="Hell Mode" color="red"/>
          </NavLink>
        </div>
      </div>
      <Outlet/>
      <div className="text-wrapper">
        <div className="page-nav">
          <NavLink to="jumbification">
            <Button text="Jumbification" color="red"/>
          </NavLink>
          <NavLink to="kill-tech">
            <Button text="Certain-Kill Techniques" color="red"/>
          </NavLink>
          <NavLink to="ai-battle">
            <Button text="AI Battles" color="red"/>
          </NavLink>
          <NavLink to="basic">
            <Button text="Basic Systems" color="red"/>
          </NavLink>
          <NavLink to="ranked-battle">
            <Button text="Ranked Battles" color="red"/>
          </NavLink>
          <NavLink to="hell-mode">
            <Button text="Hell Mode" color="red"/>
          </NavLink>
        </div>
      </div>
    </>
  )
}

const Jumbification = () => {

  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 8
  })

  return (
    <>
      <Modal modal={modal} setModal={setModal} url="max_ss_0.jpg"/>
      <StrokeTitle text="Battle on a Whole New Scale with Jumbification!"/>
      <div className="text-wrapper">
        <p className="white-text">
          The Disgaea series is known for upending expectations about SRPGs. The new Jumbification feature in Disgaea 7 Complete lets you supersize your characters! Knocking out multiple enemies in a single super-powerful blow, smashing open massive Treasure Chests... Your characters' rampages will know no bounds!
        </p>
      </div>
        <div className="esrb-video_wrapper"
          style={{
            marginBottom: '50px'
          }}
        >
          <ReactPlayer
            className='react-player fixed-bottom ss-system'
            url={`${process.env.PUBLIC_URL}/img/ss/max.mp4`}
            width='100%'
            height='100%'
            controls = {false}
            loop
            playing
            volume={0}
            muted
          />
          <img className='mx-auto esrb' src={`${process.env.PUBLIC_URL}/img/footer/rating.svg`} alt='esrb rp-e10' 
            style={{
            position: 'absolute',
            maxWidth: '200px',
            bottom: 0,
            left: 0,
            margin: 5,
            zIndex: 2
          }}
          />
        </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/max_ss_01.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 1,
              }
            )
          }}/>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/max_ss_02.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 2,
              }
            )
          }}/>
        </div>
      </div>
      <StrokeTitle text="No Limits! No Bounds! No Quarter!"/>
      <div className="text-wrapper">
          <p className="white-text">
            Jumbified characters can attack any part of the stage! And normal attacks become area attacks, allowing you to smash groups of enemies with a single blow!
          </p>
          <p className="white-text" style={{marginTop: '25px'}}>
            Sweep the board with your jumbo characters!
          </p>
      </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/max_ss_03.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 3,
              }
            )
          }}/>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/max_ss_04.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 4,
              }
            )
          }}/>
        </div>
      </div>
      <StrokeTitle text="Command the battlefield with Jumbilities!"/>
      <div className="text-wrapper">
        <p className="white-text">
          Characters have special abilities that are only available when Jumbified: Jumbilities! Boost damage by 20%! Recover 20% of your HP at the end of the turn! And so many more powerful abilities!
        </p>
        <p className="white-text">
          Jumbilities affect everyone on the battlefield, so it's important to Jumbify the right character at the right time!
        </p>
        <p className="white-text">
          Understanding Jumbilities is the key to using Jumbification successfully!
        </p>
      </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/max_ss_05.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 5,
              }
            )
          }}/>
          <h3 className="item-text white-text">
            Prinnies have the "Everyone's a Bomb" ability...making EVERYONE explode when thrown!? <br/>
            *The exploding unit is not defeated.
          </h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/max_ss_06.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 6,
              }
            )
          }}/>
          <h3 className="item-text white-text">
            The Witch's Jumbility recovers SP, enabling you to go all-out with powerful spells and weapon skills!
          </h3>
        </div>
      </div>
      <StrokeTitle text="When Both Enemies and Allies Can Jumbify...Annihilation Ensues!"/>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/max_ss_07.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 7,
              }
            )
          }}/>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/max_ss_08.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 8,
              }
            )
          }}/>
        </div>
      </div>
      <div className="text-wrapper">
        <p className="white-text">
          Powerful enemies can Jumbify, too! Check what kind of Jumbilities and stats they have, and face them in jumbo combat. Up to 4 Jumbified characters can duke it out at a time! You won't want to miss this!
        </p>
      </div>
    </>
  )
}

const KillTech = () => {

  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 5
  })

  return (
    <>
      <Modal modal={modal} setModal={setModal} url="skill_0.jpg"/>
      <StrokeTitle text="Hone Your Killer Weapon Techniques!"/>
      <div className="text-wrapper">
        <p className="white-text">
        There are 7 weapon types, such as swords and spears. Keep using the same type to unlock powerful special skills! Use weapon skills with various ranges and areas of effect to sweep enemies aside!
        Magic Knights who fight with fists? Martial Artist snipers!? Anything goes with these crazy characters!
        </p>
      </div>
      <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/skill_01.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 1,
              }
            )
          }}/>
        </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/skill_02.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 2,
              }
            )
          }}/>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/skill_03.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 3,
              }
            )
          }}/>
        </div>
      </div>
      <StrokeTitle text="Strike from Afar! Magic Attacks Spell Destruction!"/>
      <div className="text-wrapper">
          <p className="white-text">
          Some characters learn spells as they advance! There are three main magical elements: fire, wind, and water.

          Blast through enemies' weak points to deal massive damage! Continued use will improve your magic, allowing you to target distant enemies with powerful spells! <br/>

          Use your favorite spells as much as possible and watch their power grow!

          (By meeting the right conditions, any character can learn magic!)
          </p>
      </div>
      <div className="pair">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/skill_04.jpg`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 4,
                }
              )
        }}/>
      </div>
      <div className="item">
        <img className="large-ss ss-system " src={`${process.env.PUBLIC_URL}/img/ss/skill_05.jpg`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 5,
                }
              )
        }}/>
        <h3 className="item-text white-text">
          Gorgeous illustrations appear when you use the more powerful spells!
        </h3>
      </div>
    </>
  )
}

const AIBattles = () => {
  
  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 6
  })

  return (
    <>
      <Modal modal={modal} setModal={setModal} url="ai_ss_0.jpg"/>
      <StrokeTitle text="Use AI to Get More Bang for Your Disgaea Buck (HL)!"/>
      <div className="text-wrapper">
        <p className="white-text">
          In Disgaea 7 Complete, set each unit’s Demonic Intelligence to unlock the game's full potential and fun!

          You can use the preset options at first, but once you're familiar with the system, try setting them yourself. Find the perfect D.I. for any situation, and characters' win rates will improve before your very eyes!
        </p>
      </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/ai_ss_01.jpg`} alt="Top-SS" onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 1,
                  }
                )
          }}/>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/ai_ss_02.jpg`} alt="Top-SS" onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 2,
                  }
                )
          }}/>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/ai_ss_03.jpg`} alt="Top-SS" onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 3,
                  }
                )
          }}/>
          <h3 className="item-text white-text">You can input multiple D.I. patterns. Create settings for various potential scenarios, then sit back, relax, and enjoy the frenzy!</h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/ai_ss_04.jpg`} alt="Top-SS" onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 4,
                  }
                )
          }}/>
          <h3 className="item-text white-text">You can start by creating custom templates!</h3>
        </div>
      </div>
      <StrokeTitle text="Level Smarter, Not Harder"/>
        <div className="text-wrapper">
          <p className="white-text">
            Use Poltergas, a new special item, to run an Auto-Battle on a stage you've already cleared. Characters act according to their D.I. settings and automatically clear the stage. The amount of Poltergas consumed depends on how many turns it takes to win, so in order to level efficiently using minimal Poltergas, set your AI to work for the current stage.
          </p>
        </div>
        <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/ai_ss_05.jpg`} alt="Top-SS" onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 5,
                  }
                )
          }}/>
          <h3 className="item-text white-text">You can only run an Auto-Battle on previously cleared stages.</h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/ai_ss_06.jpg`} alt="Top-SS" onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 6,
                  }
                )
          }}/>
          <h3 className="item-text white-text">The amount of Poltergas consumed is equal to how many turns it takes you to win. Use this item to skip battles while gaining EXP and other rewards.</h3>
        </div>
        </div>
        <StrokeTitle text="Conquer Stages to Obtain Poltergas!"/>
        <div className="text-wrapper">
          <p className="white-text">
            Poltergas is required for Auto-Battles, and you must clear stages manually to obtain it. You also gain a little Poltergas from advancing the story and conquering Item Worlds!

            When enemies are too tough, use your supply of Poltergas to improve your characters, and then take on your foe once more!

            Use AI for Fast Leveling!
          </p>
        </div>
    </>
  )
}

const Basic = () => {

  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 3
  })

  return (
    <>
      <Modal modal={modal} setModal={setModal} url="basic_0.png"/>
      <StrokeTitle text="An SRPG that Breaks All the Rules!"/>
      <div className="text-wrapper">
        <p className="white-text">
          Anything goes in the Disgaea series! <br/>

          Max level of 9,999! Damage in the hundreds of millions! Lifting and throwing enemies and allies alike during battle! You won't see systems like these in other SRPGs--use them to conquer the entire Netherworld!
        </p>
      </div>
      <div className="pair">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/basic_01.png`} alt="Top-SS" onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 1,
                  }
                )
          }}/>
           <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/basic_02.png`} alt="Top-SS" onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 2,
                  }
                )
          }}/>
      </div>
      <StrokeTitle text="Gang Up on Enemies with Team Attacks!"/>
      <div className="text-wrapper">
        <p className="white-text">
          Use Team Attacks with nearby allies to boost your damage! In addition to upping your damage output, you'll also trigger special character cut-ins! When you find a character you like, go all in!
        </p>
      </div>
      <div className="item">
        <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/basic_03.png`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 3,
                }
              )
        }}/>
        <h3 className="item-text white-text">
          Team Attacks trigger special character cut-ins!
        </h3>
      </div>
      <StrokeTitle text="Lift & Throw Your Way to Victory!"/>
      <div className="text-wrapper">
        <p className="white-text">
          You can lift and throw both allies and enemies during battle. Throw an ally to quickly close the distance to enemies, or buy some time by flinging enemies far away. Master lifting and throwing to expand your combat potential!
        </p>
      </div>
        <div className="esrb-video_wrapper">
          <ReactPlayer
            className='react-player fixed-bottom ss-system'
            url={`${process.env.PUBLIC_URL}/img/ss/basic.mp4`}
            width='100%'
            height='100%'
            controls = {false}
            loop
            playing
            volume={0}
            muted
          />
          <img className='esrb mx-auto' src={`${process.env.PUBLIC_URL}/img/footer/rating.svg`} alt='esrb rp-e10' 
            style={{
            position: 'absolute',
            maxWidth: '200px',
            bottom: 0,
            right: 0,
            margin: 5,
            zIndex: 2
          }}
          />
        </div>
    </>
  )
}

const RankedBattles = () => {
  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 10
  })

  return (
    <>
    <Modal modal={modal} setModal={setModal} url="rank_0.png"/>
      <StrokeTitle text="Conquer the World with AI Combat!"/>
      <div className="text-wrapper">
        <p className="white-text">
          Ranked Battles are a first in the series. After training up your party, pit them against other players around the country in AI battles!

          Optimize your strategies to match the stage and opponent.

          Test your tactics through trial and error, and lead your team to victory!
        </p>
      </div>
      <StrokeTitle text="Learn the Basics of Ranked Battles!"/>
      <div className="text-wrapper">
        <p className="white-text">
          Ranked Battles are a new system where you can have your team fight against other players around the country in order to gain ranking points. As you keep battling, your rank will rise with wins...and drop with losses. Keep winning to raise your rank all the way to the top!
        </p>
      </div>
      <StrokeTitle text="Battle Prep: Setting AI"/>
      <div className="text-wrapper">
        <p className="white-text">
          During Ranked Battles, characters operate according to their Demonic Intelligence. Set your AI to match the stage and rules! You can also have plenty of fun using the default options.

          "Charge" will make your units aggressive, "Heal" will make your units focus on healing, etc. Try using the defaults while you are still getting used to the system.
        </p>
      </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rank_01.png`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 1,
                }
              )
        }}/>
        <h3 className="item-text white-text">
          Ranked Battles are AI battles using Demonic Intelligence (D.I.). Make sure to set your D.I. for Ranked Battles when participating.
        </h3>
        </div>
        <div className="pair">
          <div className="item">
            <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rank_02.png`} alt="Top-SS" onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 2,
                  }
                )
          }}/>
          <h3 className="item-text white-text">
            Edit the units you will deploy at the Ranked Battle Shop. Once you've confirmed your members, you will proceed to the initial placement settings.
          </h3>
          </div>
          <div className="item">
            <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rank_03.png`} alt="Top-SS" onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 3,
                  }
                )
          }}/>
          <h3 className="item-text white-text">
            Once their placement is set, upload your team. Now you're ready to join a Ranked Battle!
          </h3>
          </div>
        </div>
      </div>
      <StrokeTitle text="Figure Out What Works and Choose Your Enemies Wisely!"/>
      <div className="text-wrapper">
        <p className="white-text">
          Three random opponents with ranks close to yours will be selected. Check their team configurations and ranks to plan your strategy. Choose your opponent wisely!
        </p>
      </div>
      <div className="item">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rank_04.png`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 4,
              }
            )
      }}/>
      <h3 className="item-text white-text">
        Before fighting the opponent you have selected, you can check their force composition and levels.
      </h3>
      </div>
      <div className="text-wrapper">
        <StrokeTitle text="Stages Galore!"/>
        <p className="white-text">
          Stages also change with each season. Stages may be covered in Geo Panels, greatly affecting the course of battle. Choosing your members and strategies based on the stage is key!
        </p>
        <div className="pair">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rank_05.png`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 5,
              }
            )
          }}/>
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rank_06.png`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 6,
              }
            )
          }}/>
        </div>
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rank_07.png`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 7,
              }
            )
          }}/>
        <StrokeTitle text="Rules and Stages Both Change Each Season!"/>
        <p className="white-text">
          Aside from the stage, other rules may also apply, such as only being allowed to field a team of Monsters! Cultivate a wide range of characters so you can adapt to any situation!
        </p>
      </div>

      <StrokeTitle text="Two Modes for Ranked Battle Practice!"/>
      <AltTitle text=" Test Battle - Practice Your Moves with an AI Party!"/>
      <div className="text-wrapper">
        <p className="white-text">
          Test yourself against a party of fixed AI opponents, where you can edit your D.I. settings mid-battle. Once you've pondered your moves and tweaked your D.I., it's time for the more realistic Free Battle!
        </p>
      </div>
      <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rank_08.png`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 8,
              }
            )
          }}/>
      <AltTitle text="Free Battle - Hands-On Practice with D.I.!"/>
      <div className="text-wrapper">
        <p className="white-text">
          This mode won't affect your rank, regardless of whether you win or lose. Use this mode to try out different teams and tactics at your own pace. If things go well here, your D.I. is more than ready for a fully-fledged Ranked Battle!
        </p>
      </div>
      <div className="pair">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rank_09.png`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 9,
              }
            )
          }}/>
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rank_010.png`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 10,
              }
            )
          }}/>
      </div>
    </>
  )
}

const Hell = () => {
  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 2
  })

  return (
    <>
      <Modal modal={modal} setModal={setModal} url="revenge_ss_0.png"/>
      <StrokeTitle text="Control Legendary Powers with Hell Mode!"/>
      <div className="text-wrapper">
        <p className="white-text">
          Some characters can build up their Hell Gauge during battle. Once this gauge is maxed out, you can unleash the full power of your Demonic Weapons with Hell Mode!

          Hell Mode nets you more EXP, and unlocks various special skills as well!

          These powers are legendary across Hinomoto--tap into them to crush all who stand in your way!
        </p>
      </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/revenge_ss_01.png`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 1,
              }
            )
          }}/>
          <h3 className="white-text item-text">
            Charging conditions will vary, depending on the character.
          </h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/revenge_ss_02.png`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 2,
              }
            )
          }}/>
          <h3 className="white-text item-text">
          All Hell Mode abilities are super powerful!
        </h3>
        </div>
      </div>
      <StrokeTitle text="The Seven Founding Weapons & Their Wielders"/>
      <div className="text-wrapper">
        <AltTitle text="Kanzan Musashi, the Demonic Sword"/>
        <p className="white-text">
          Fuji's Demonic Sword can slice through literally anything.

          When attacking, it greatly reduces a target's defense power, dealing a huge amount of damage.
        </p>
        <div className="esrb-video_wrapper" style={{
          marginTop: '50px'
        }}>
           <ReactPlayer
              className='react-player fixed-bottom ss-system'
              url={`${process.env.PUBLIC_URL}/img/ss/revenge1.mp4`}
              width='100%'
              height='100%'
              controls = {false}
              loop
              playing
              volume={0}
              muted
            />
            <img className='esrb mx-auto' src={`${process.env.PUBLIC_URL}/img/footer/rating.svg`} alt='esrb rp-e10' 
              style={{
                position: 'absolute',
                maxWidth: '150px',
                bottom: 0,
                left: 0,
                margin: 5,
                zIndex: 2
              }}
            />
        </div>
      </div>
      <div className="text-wrapper">
        <AltTitle text="Tokugawa Tenge, the Demonic Staff"/>
        <p className="white-text">
          Yeyasu's Demonic Staff can force any creature to obey its wielder.

          When Hell Mode activates, it inflicts Puppet on surrounding enemy units.
        </p>

       <div className="esrb-video_wrapper" style={{
        marginTop: '50px'
       }}>
         <ReactPlayer
          className='react-player fixed-bottom ss-system'
          url={`${process.env.PUBLIC_URL}/img/ss/revenge2.mp4`}
          width='100%'
          height='100%'
          controls = {false}
          loop
          playing
          volume={0}
          muted
        />
         <img className='esrb mx-auto' src={`${process.env.PUBLIC_URL}/img/footer/rating.svg`} alt='esrb rp-e10' 
          style={{
            position: 'absolute',
            maxWidth: '200px',
            bottom: 0,
            left: 0,
            margin: 5,
            zIndex: 2
          }}
        />
       </div>
      </div>
    </>
  )
}

export default CombatSystem;
export {
  Jumbification, KillTech, AIBattles, Basic, RankedBattles, Hell
};